import { RouteType } from "types/RouteType";
import AccountsListStore from "./AccountsList.Store";
import { AccountFormStore } from "./dialogs/AccountForm/AccountForm.Store";
import { RootStore } from "@intrasync/stores";

const accountsListRoute: RouteType = {
  name: "Accounts",
  path: "/crm/accounts",
  layout: "/app",
  hidden: true,
  viewportCard: {
    header: {
      title: "Accounts",
      component: () => import("./AccountsList.Header"),
    },
    body: {
      grayBackground: true,
      component: () => import("./AccountsList.Body"),
    },
  },
  group: "CRM",
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load accounts data before entering the route
    const accountsListStore = rootStore.accountsListStore as AccountsListStore;

    await accountsListStore.loadAccounts();

    return true;
  },
  dialogs: [
    {
      name: "Account Form",
      component: () => import("./dialogs/AccountForm/AccountForm.Body"),
      title: "Account Form",
      height: 840,
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const accountFormStore = rootStore.accountFormStore as AccountFormStore;

        // Use the correct method name from AccountFormStore
        const result = await accountFormStore.saveAccount();
        if (result) {
          // Refresh the accounts list after successful submission
          const accountsListStore =
            rootStore.accountsListStore as AccountsListStore;
          await accountsListStore.loadAccounts();
        }
        return !!result;
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const accountFormStore = rootStore.accountFormStore as AccountFormStore;
        const formData = accountFormStore.formData;

        // Only name is required per API schema
        if (!formData.name) return false;

        // // Validate website URL format if provided
        // if (formData.website && !/^https?:\/\/.+/.test(formData.website))
        //   return false;

        // // Validate email format if provided
        // if (
        //   formData.email &&
        //   !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
        // )
        //   return false;

        return false;
      },
    },
    {
      name: "accountDetail",
      component: () => import("./dialogs/AccountDetail/AccountDetail.Body"),
      title: "Account Details",
      cancelButton: true,
      height: 830,
    },
  ],
};

export default accountsListRoute;
